<template>
  <div>
    <v-dialog
        v-model="dialogDelete"
        width="500">
      <v-card class="card-custom" style="background-color: #f5f5f5 !important;">
        <v-card-title>
          <v-row>
            <v-col cols="10" class="text-left text-h5 font-weight-bold" style="color: #3A3852">
              Delete manager
            </v-col>
            <v-col cols="2" class="text-right action">
              <span class="font-weight-bold text-h6" @click="closeModal">
                 X
              </span>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="pa-5 text-center font-weight-bold">
          You are about to delete a manager:
          <div class="primary-color">
            {{this.currentItem.name}} - {{this.currentItem.access }} ?
          </div>
          Are you sure?
        </v-card-text>
        <v-card-actions>
          <v-col class="text-right">
            <v-btn class="copy-btn" @click="deleteItem()">
              YES, DELETE
            </v-btn>
          </v-col>

        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="search_btn_wrap flex v_center">
      <h1 class="mb-0 mr-4">New Managers</h1>
      <v-btn
          color="primary"
          x-small
          @click="showPopup = true, selectedItem = null"
          style="min-width: 0; min-height: 30px"
      >
      <span style="font-size: 24px">
          <i class="fas fa-plus"></i>
        </span>
      </v-btn>
      <v-spacer></v-spacer>
      <span class="inactive_offer_text">Show inactive managers</span>
      <v-switch
          v-model="showInactiveManagers"
          class="inactive_offer_switch"
      ></v-switch>

    </div>

    <v-data-table
        :headers="table.headers"
        :items="getAccountManagers.data"
        :header-props="{ sortIcon: null, headerClass: 'white-space-no-wrap' }"
        :server-items-length="getAccountManagers.count"
        :disable-sort="true"
        :footer-props="{ itemsPerPageOptions: table.pageOptions }"
        :items-per-page="table.perPage"
        :loading="table.loading"
        item-key="id"
        loading-text="Loading... Please wait"
        :class="`elevation-1 fixed-height co-data-table items-size-${table.heightCounter}`"
        fixed-header
        item-class="td_title"
        color="#7F98A5"
        @pagination="updateTablePagination"
    >
      <template v-slot:top>
        <DataTableTopBar @search="search"></DataTableTopBar>
      </template>

      <template v-for="item of table.headers" :slot="`header.${[item.value]}`" slot-scope="{header}">
        <data-filter type="items"
                     v-if="table.filters.hasOwnProperty(header.value)"
                     :items="table.filters[header.value].data"
                     :entity="header.value"
                     :values="table.filters[header.value].selected"
                     @apply="submitFilter"
        ></data-filter>
        <a v-if="header.sortable === undefined || header.sortable" @click="sortColumn(header.value)">
          <span class="header_title">{{header.text}}</span>
          <v-icon size="16" color="#7F98A5">mdi-arrow-{{header.value === table.orderBy ? table.sortColumnsAsc ? 'up' : 'down' : 'up-down'}}</v-icon>
        </a>
        <span v-else class="header_title">{{header.text}}</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="d-flex align-center">
          <v-btn icon color="primary" @click="editItem(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>

          <v-switch
              v-model="item.status === 'active'"
              class="mr-2"
              @change="handleStatusChange(item)"
              :title="item.status === 'active' ? 'Switch to inactive' : 'Switch to active'"
          ></v-switch>
          <v-btn icon color="primary" @click="history(item)">
            <v-icon>mdi-history</v-icon>
          </v-btn>
        </div>
      </template>

      <template v-slot:item.preSignedUrl="{ item }">
        <div v-if="item.preSignedUrl" style="display: flex; justify-content: center; align-items: center; height: 50px;">
          <a :href="item.preSignedUrl" target="_blank">
            <v-img :src="item.preSignedUrl" width="50px" height="50px" alt="Asset" />
          </a>
        </div>
        <div v-else>
          {{ item.value }}
        </div>
      </template>

      <template v-slot:item.tags="{ item }">
        <div class="tags-container">
          <v-chip
              v-for="(tags, index) in item.tags"
              :key="index"
              color="primary"
              class="tag"
              text-color="white">
            {{ tags.name }}
          </v-chip>
        </div>
      </template>

    </v-data-table>

    <account-managers-popup
        :value="showPopup"
        :item="this.selectedItem ? this.selectedItem : null"
        v-if="showPopup"
        @close="showPopup = false"
        @createOrUpdateAccountManager="handleCreateOrUpdateAccountManager"
    />
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import DataTableTopBar from "@/components/common/DataTableTopBar.vue";
import CustomAssetPopup from "@/components/pages/affiliates/customAssets/CustomAssetPopup.vue";
import AccountManagersPopup from "@/components/pages/managers/accountManagersPopup.vue";
import managers from "@/api/managers";

export default {
  name: 'AccountManagers',
  components: {AccountManagersPopup, CustomAssetPopup, DataTableTopBar},
  computed: {
    ...mapGetters('managers', ['getAccountManagers','filters']),
    ...mapState('user', ['user']),
  },
  watch: {
    showInactiveManagers: async function () {
      await this.getTableData()
    },
  },
  methods: {
    ...mapActions('alert', ['ALERT_SUCCESS']),
    ...mapActions('managers', [
      'saveAccountManagers',
      'saveUmbrellaUsers',
      'createOrUpdateAccountManagerStore',
      'getAccountManagerFilterDataStore',
      'deleteManagerStore'
    ]),
    search(searchText) {
      this.searchIn = searchText;
      this.submitFilter();
    },
    async sortColumn(column) {
      this.table.sortColumnsAsc = (this.table.orderBy === column) ? !this.table.sortColumnsAsc : true;
      this.table.orderBy = column
      await this.getTableData()
    },
    async getFiltersData() {
      Object.keys(this.table.filters).forEach(name => {
        if (this.filters[name]) {
          this.table.filters[name]['data'] = this.filters[name];
          if (this.table.filters[name]['isRange']) {
            this.table.filters[name].min = Number(this.filters[name].find(f => f.key === 'min')['value']);
            this.table.filters[name].max = Number(this.filters[name].find(f => f.key === 'max')['value']);
          }
        }
        this.table.filters[name].data = this.filters[name]
      })
    },
    async getFilters() {
      const filters = {};
      filters['search'] = (this.searchIn.length > 0) ? this.searchIn : '';
      for(const name in this.table.filters) {
        filters[name] = (this.table.filters[name].selected.length > 0) ?
            `'${this.table.filters[name].selected.join('\',\'')}'` :
            null;
      }
      return filters;
    },
    async submitFilter(data, entity) {
      this.table.currentPage = 1;
      if(data && entity) {
        this.table.filters[entity].selected = data;
      }
      return await this.getTableData()
    },
    async editItem(item) {
      this.selectedItem = item;
      this.showPopup = true;
      return this.selectedItem;
    },
    closeModal() {
      this.dialogDelete = false;
    },
    async openModal(item) {
      this.currentItem = { ... item}
      this.dialogDelete = true;
    },
    async deleteItem( ) {
      await this.deleteManagerStore(this.currentItem.id);
      this.dialogDelete = false;
    },
    async history(item) {
      await this.$router.push(`/managers/accountManager/history/${item.id}`);
    },
    async handleStatusChange(item) {
      const newManagerData = {
        ...item,
        isSwitchStatus: true,
        status: item.status === 'active' ? 'inactive' : 'active',
      };
      await this.handleCreateOrUpdateAccountManager(newManagerData);
    },
    async handleCreateOrUpdateAccountManager(newManagerData) {
      newManagerData.user = this.user[0].email.split("@")[0];
      await this.createOrUpdateAccountManagerStore(newManagerData);
    },
    async getTableData() {
      this.table.loading = true
      const filters = await this.getFilters();
      await this.saveAccountManagers({
        filters,
        limit: this.table.perPage,
        page: this.table.currentPage,
        isShowInactive: this.showInactiveManagers,
        orderBy: this.table.orderBy,
        orderDirectionAsc: this.table.sortColumnsAsc,
      });
      this.table.loading = false
    },
    async updateTablePagination(params){
      this.table.currentPage = params.page
      this.table.perPage = params.itemsPerPage
      await this.getTableData()
    },
  },
  data() {
    return {
      searchIn: '',
      dialogDelete: false,
      currentItem: [],
      showPopup: false,
      selectedItem: null,
      showInactiveManagers: false,
      table: {
        heightCounter: 48,
        loading: false,
        awaitingSearch: false,
        currentPage: 1,
        itemsPerPage: 25,
        pageChangedByMe: false,
        pageOptions: [25, 50, 100],
        orderBy: 'id',
        sortColumnsAsc: true,
        headers: [
          { text: 'ID', value: 'id' },
          { text: 'Name', value: 'name' },
          { text: 'Role', value: 'role' },
          { text: 'Email', value: 'email' },
          { text: 'Status', value: 'status' },
          { text: 'Skype ID', value: 'skypeId', align: 'center', sortable: false },
          { text: 'Created At', value: 'dateAdded' },
          { text: 'Last Updated At', value: 'dateUpdated' },
          { text: 'Last Updated By', value: 'user' },
          { text: 'Actions', value: 'actions', align: 'center', sortable: false },
        ],
        filters: {
          id: {active: false, selected: [], show: false, property: '', data: []},
          name: {active: false, selected: [], show: false, property: '', data: []},
          role: {active: false, selected: [], show: false, property: '', data: []},
          email: {active: false, selected: [], show: false, property: '', data: []},
          skypeId: {active: false, selected: [], show: false, property: '', data: []},
          status: {active: false, selected: [], show: false, property: '', data: []},
        }
      },
      tableHeaders: [

      ],
    };
  },
  async mounted() {
    if (!this.user[0].can('manage_account_managers')){
      await this.$router.push('/403');
    }
    await this.getTableData()
    await this.getAccountManagerFilterDataStore();
    await this.getFiltersData()

  },
};
</script>

<style lang="sass">
.tags-container
  display: grid
  grid-template-columns: repeat(2, max-content)
  gap: 4px
  justify-content: flex-start
  align-items: center

  .tag
    display: inline-block
    margin: 0

@media (max-width: 600px)
  .tags-container
    grid-template-columns: repeat(1, max-content)

</style>